import { getOrThrow } from 'quartz-core-utils/globalState/api';
import { HISTORY_INSTANCE } from '../frameworkInternal/tools/history/history';

/**
 * Returns the current history instance for the app. This should only be used in exceptional cases where the history
 * instance is not available through React context with `useHistory` or `withRouter`.
 *
 * @example
 * ```ts
 * import { getHistory } from 'quartz-core/framework/history';
 *
 * const href = getHistory().createHref({ pathname: '/some/path' });
 * ```
 */
export const getHistory = () => getOrThrow(HISTORY_INSTANCE);